import React from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App.js";
import { RootErrorBoundary } from "./components/RootErrorBoundary.js";
import { installGlobalErrorReporter } from "./lib/client-error.js";
import { initI18n } from "./lib/i18n.js";
import { logger } from "./lib/logger.js";
import { bootstrapWebApp } from "./lib/telegram.js";
import { appDisplayName, hereticOgImage } from "./lib/heretic.js";
import "@tgpe/editor-core/styles.css";
import "./styles/globals.css";

// Install BEFORE bootstrap: bootstrap can throw on old Telegram clients
// and we want even those errors to land in cluster logs.
installGlobalErrorReporter();

const wa = bootstrapWebApp();
const i18n = initI18n(wa?.initDataUnsafe.user?.language_code);

const lang = i18n.language;
const displayName = appDisplayName(lang);
document.documentElement.lang = lang;
document.title = displayName;
const ogTitle = document.querySelector('meta[property="og:title"]');
if (ogTitle) ogTitle.setAttribute("content", displayName);
const ogImage = document.querySelector('meta[property="og:image"]');
if (ogImage) ogImage.setAttribute("content", hereticOgImage(lang));

const container = document.getElementById("root");
if (!container) {
  logger.error("missing #root container");
} else {
  createRoot(container).render(
    <React.StrictMode>
      <RootErrorBoundary>
        <App />
      </RootErrorBoundary>
    </React.StrictMode>,
  );
}
